enum ThemeType {
  Dynamic,
  Light,
  Dark
}

export default ThemeType;
